import React, { useEffect, useState } from "react";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

function DateInput({ label, onChange }) {
  const [date, setDate] = useState();

  useEffect(() => {
    if (date) {
      const formattedDate =
        date.getFullYear() +
        "-" +
        String(date.getMonth() + 1).padStart(2, "0") +
        "-" +
        String(date.getDate()).padStart(2, "0");
      onChange(formattedDate);
    }
  }, [date]);

  return (
    <div className="flex flex-col">
      <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
        {label || ""}
      </label>
      <DatePicker
        value={date}
        onChange={(e) => setDate(new Date(e))}
        calendar={persian}
        inputClass="h-10 rounded-md border text-center"
        locale={persian_fa}
        calendarPosition="bottom-right"
      />
    </div>
  );
}

export default DateInput;
